import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthConsumer } from 'contexts/auth'

const AuthenticatedRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    <AuthConsumer>
      {({ isAuthenticated }) => (
        <Route
          render={
            props =>
              isAuthenticated
                ? <Component {...props} />
                : <Redirect to={{
                  pathname: '/signup',
                  state: { prevUrl: window.document.URL }
                }} />
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  )} />
)

export default AuthenticatedRoute